// extracted by mini-css-extract-plugin
export default {"Sidebar":"SidebarOverlay_Sidebar__6HW7a","content":"SidebarOverlay_content__2Kbmb","xmark":"SidebarOverlay_xmark__CaG+E","menu":"SidebarOverlay_menu__aBXY0"};